let getUrlParameter = function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

const $header = $('header.masthead');

$('.tabs').each(function () {
    let $tabs = $(this);

    $('.tab, .mobile-tab', this).on('click', function () {
        let tabID = $(this).attr('data-tab-id');

        if (typeof tabID !== 'undefined') {
            $('.tab[data-tab-id="'+tabID+'"]').attr('data-state', 'active').siblings('.tab').attr('data-state', '');
            $('.mobile-tab[data-tab-id="'+tabID+'"]').attr('data-state', 'active').siblings('.mobile-tab').attr('data-state', '');
            $('.tab-panel[data-tab-id="'+tabID+'"]').attr('data-state', 'active').siblings('.tab-panel').attr('data-state', '');

            // add url parameter for active tab
            window.history.replaceState(null, null, '?tab=' + tabID);
        }

        $(this).blur();
    });

    // init: open active tab based on url parameter
    if (getUrlParameter('tab')) {
        let tabID = getUrlParameter('tab');

        $('.tab[data-tab-id="'+tabID+'"]').trigger('click');
    }

    // init: check for active tab or make one
    if ($('.tab[data-state="active"]', this).length < 1) {
        $('.tab', this).first().attr('data-state', 'active').trigger('click');
    }
});
